import { LatLong } from '../common';
import { EnvConfig } from '../config';
import { httpRequest } from './httpUtils';
import { Lock, Response, Status } from './types';

export interface TimeGeo extends LatLong {
  msepoch: string;
  georegion: string;
  country_code: string; // eslint-disable-line camelcase
  city: string;
  timezone: string;
  continent: string;
  throughput: string;
  bw: string;
  location_id: string; // eslint-disable-line camelcase
}

const withLocalTimeBackup = (response: Response<TimeGeo>): Response<TimeGeo> => {
  if (response.payload) {
    return response;
  }
  return {
    status: Status.ERROR,
    payload: {
      msepoch: String(Date.now()),
    } as TimeGeo,
  };
};

const lock: Lock = new Lock();

export const getTimeGeo = ({ timeGeoUrl }: EnvConfig): Promise<Response<TimeGeo>> => {
  lock.cancel();

  return httpRequest<TimeGeo>({
    method: 'GET',
    url: timeGeoUrl,
    timeout: 3000,
    retries: 2,
    lock,
  })
    .then(withLocalTimeBackup)
    .catch(withLocalTimeBackup)
    .finally(() => lock.release);
};
